// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__G1E4j","logo":"styles_logo__mbg9j"};